import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export interface IVcfFuelStatusResponse {
    readonly data?: [{
        readonly carCapturedTimestamp: string;
        readonly properties: {
            readonly name: string;
            readonly value: string;
        }[];
    }];
}

// https://cardata.apps.emea.vwapps.io/documentation#tag/Fuel-Status
export class VcfFuelStatusClient {

    private readonly headers: HeadersInit = {
        'User-Id': '__userId__',
    };

    private readonly resourceHostId: string;

    private getGdcType = (isWcar: boolean) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;

    constructor(private readonly authServiceWeConnect: IAuthServiceV2, private readonly stage: string) {
        this.resourceHostId = `myvw-vcf-${stage}`;
    }

    // https://cardata.apps.emea.vwapps.io/documentation#tag/Fuel-Status/operation/getFuelStatus
    public async getFuelStatus(vin: string, isWcar: boolean): Promise<IVcfFuelStatusResponse | undefined> {
        const url = `vehicles/${vin}/fuel/status?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authServiceWeConnect.get(this.resourceHostId, url, this.headers);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json();
    }
}